enum EDownloadStatus {
  not_requested = "Download",
  requested = "Preparing Files",
  ready = "Download Now",
}

export default EDownloadStatus;
